import React from 'react';
import { Form, Input, Alert } from 'antd';

import formItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';

class CabinType extends React.Component {
	state = {
		cabinType: null
	}
	handleSubmit = (event) => {
		event.preventDefault();
	}
	getCabinTypeFromProps = (props) => {
		if (!this.props.bookingLoaded) return this.setState({ cabinType: null });
		const cabinTransaction = props.transactions
			.find(transaction => transaction.BaseMessage.toLowerCase().indexOf('cabin') !== -1);
		if (!cabinTransaction) return this.setState({ cabinType: 'Unknown' });
		this.setState({ cabinType: cabinTransaction.BaseMessage.split('Cabin:')[1] });
	}
	componentDidMount() { this.getCabinTypeFromProps(this.props); }
	componentWillReceiveProps(nextProps) { this.getCabinTypeFromProps(nextProps); }
	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'cabin/type');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		return (
			<div>
				 <Alert showIcon type="info"
                        message="Cabin Type Preferences"
                        description={<div><span>Please note that this section indicates your <strong>cabin type <i>preference</i></strong> and is <font style={{textDecorationLine: 'underline'}} >NOT</font> a <strong>finalized cabin <i>assignment</i>.</strong> Final cabin assignments are not made until 1 week prior to embarkation. Students will learn their cabin number and roommate at embarkation. Semester at Sea will make every effort possible to accommodate all cabin type preferences. Should Semester at Sea need to change your cabin type preference at the time of assigning cabins for any reason, you will be notified directly by Program Administration. Cabin assignments are at the sole discretion of Semester at Sea - please refer to Section 6 of the <a href="http://www.semesteratsea.org/wp-content/uploads/2016/07/Ticket-Contract-July-2016.pdf" target="blank">ticket contract</a> for cabin assignment policies.</span> <br /><br /> <span>If the cabin type preference listed below is not what you chose when placing your confirmation deposit, don’t worry! Your preferred cabin type may be full, in which case you have been placed on a waitlist. Cabin preference changes will be considered in the order of deposit, and can occur all the way up until two weeks prior to embarkation. Questions about cabins? E-mail <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>.</span></div>} />
			{/* <Alert showIcon type="info"
					message="Is the cabin type listed not the cabin you chose?"
		description={<span>Please keep in mind that we place students in cabin categories on a first come, first served basis. If your cabin assignment below does not match your first choice of cabin, your chosen cabin type is likely full. If your first choice of cabin type was not available, don't worry! We have placed you on a waitlist. Cabin reassignments will be considered in the order of deposit. Keep in mind that cabin changes occur all the way up until two weeks prior to sailing. Please reach out to us at <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a> if you have serious concerns about your cabin placement.  We cannot guarantee placement, but we will do our best to accommodate your primary requests. <a target="blank" href="https://www.semesteratsea.org/cabin-tours/">Click here</a> to go on a cabin tour.</span>} /> */}
			<br />
			<Form onSubmit={this.handleSubmit}>
				<Form.Item label="Cabin Type" {...formItemLayout} className="inResco">
					{getFieldDecorator('cabinType', {
						initialValue: this.state.cabinType
					})(
						<Input disabled />
					)}
				</Form.Item>
			</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(CabinType));



// WEBPACK FOOTER //
// ./portal-components/Portal/Cabin/CabinType.jsx